function create({
                    product,
                    texts,
                    mainThumbnail,
                    fitFinderData,
                    currentProductId,
                    allProductIds,
                    sizes,
                    performAddToCart,
                    performSelectSize,
                    resolveCurrentSize,
                    resolveCartItems
}) {

    const {userId, SSID, shopLanguage, shopCountry} = fitFinderData;

    return {
        shopLanguage,
        shopCountry,
        mainThumbnail,
        userId,
        currentProductId,
        allProductIds,
        SSID,
        sizes,
        operations: {
            getAddToCartBtn: function () {
                return document.querySelector('[jsh-product__cart-button]');
            },
            getSizeChartLink: function () {
                return document.querySelector('[jsh-product__size-table-link]');
            },
            addToCart: function (productId, size) {
                return performAddToCart(product, texts, productId, size);
            },
            selectSize: function (productId, size) {
                performSelectSize(product, productId, size);
            },
            getCurrentSize: function () {
                return resolveCurrentSize(product);
            },
            getCartItems: function () {
               return resolveCartItems();
            },
        }
    };
}
export default {
    create
}